import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
export const COMPLETE_STOP = 'COMPLETE_STOP';
export const ADD_POD = 'ADD_POD';
export const ADD_DOCUMENTS = 'ADD_DOCUMENTS';
export const ADD_NUMBER = 'ADD_NUMBER';
export const SCHEDULE_APPT = 'SCHEDULE_APPT';
export const CONFIRM_APPT = 'CONFIRM_APPT';
export const ADD_CONTAINER = 'ADD_CONTAINER';
export const ENTER_REQUIRED_DATES = 'ENTER_REQUIRED_DATES';
export const PROVIDE_ARRIVAL_INFORMATION = 'PROVIDE_ARRIVAL_INFORMATION';
const REQUIREMENT_TAB = !featureEnabled(CONFIGURED_FEATURES.SSR) ? ADD_POD : ADD_DOCUMENTS;
export const NEXT_ACTIONS_STATUS = {
    COMPLETE_PICKUP: 'COMPLETE_STOP',
    COMPLETE_EMPTY_PICKUP: 'COMPLETE_STOP',
    COMPLETE_DELIVERY: 'COMPLETE_STOP',
    COMPLETE_EMPTY_DELIVERY: 'COMPLETE_STOP',
    COMPLETE_OFFSITE_PICKUP: 'COMPLETE_STOP',
    COMPLETE_OFFSITE_EMPTY_PICKUP: 'COMPLETE_STOP',
    COMPLETE_OFFSITE_DELIVERY: 'COMPLETE_STOP',
    COMPLETE_OFFSITE_EMPTY_DELIVERY: 'COMPLETE_STOP',
    ADD_CONTAINER: 'COMPLETE_STOP',
    ADD_DOCUMENTS: 'ADD_DOCUMENTS',
    PROVIDE_ARRIVAL_INFORMATION: 'COMPLETE_STOP',
    CONFIRM_APPT: 'CONFIRM_APPT',
    ADD_NUMBER: 'ADD_NUMBER',
    SCHEDULE_APPT: 'SCHEDULE_APPT',
    INVALID_POD: 'ADD_POD',
    PROVIDE_POD: 'ADD_POD',
    ENTER_REQUIRED_DATES: 'ENTER_REQUIRED_DATES',
};
export const NEXT_ACTION_COLOR = {
    COMPLETE_STOP: 'blue',
    CONFIRM_APPT: 'purple',
    ADD_NUMBER: 'yellow',
    SCHEDULE_APPT: 'green',
    ADD_POD: 'red',
    ADD_DOCUMENTS: 'red',
    ENTER_REQUIRED_DATES: 'indigo',
};
export const TABS = [
    {
        name: SCHEDULE_APPT,
        color: NEXT_ACTION_COLOR.SCHEDULE_APPT,
    },
    {
        name: CONFIRM_APPT,
        color: NEXT_ACTION_COLOR.CONFIRM_APPT,
    },
    {
        name: ENTER_REQUIRED_DATES,
        color: NEXT_ACTION_COLOR.ENTER_REQUIRED_DATES,
    },
    {
        name: COMPLETE_STOP,
        color: NEXT_ACTION_COLOR.COMPLETE_STOP,
    },
    {
        name: REQUIREMENT_TAB,
        color: NEXT_ACTION_COLOR.ADD_POD,
    },
];
export const DEFAULT_FILTERS = [
    {
        key: 'shipment',
        name: 'SHIPMENT',
        type: 'shipment',
        placeholder: 'Select a shipment...',
    },
    {
        key: 'date',
        name: '',
        type: 'date',
    },
];
export const SORTING_OPTIONS = [
    {
        value: 'created_at__desc',
        name: 'NEWEST_SHIPMENT_FIRST',
    },
    {
        value: 'created_at__asc',
        name: 'OLDEST_SHIPMENT_FIRST',
    },
];
